import { waitForElement, isMobile, mainCategoryClass, _t } from '../base.js'

export const initNavigation = () => {
    addWidthToMenuLevel2()
    addContactInfo()
    navigationHighlightedCategories()
    changeSubcategoriesImagesSrc()
    addMobileMenuHeading()
    tweakBrandsUrls()
    document.addEventListener('resizeEnd', () => {
        addWidthToMenuLevel2()
    })

    setTimeout(() => {
        shoptet.menu.splitMenu()
    }, 100)
}

function tweakBrandsUrls() {
    const htmlLang = $('html').attr('lang') || 'cs'

    let prefix = '/znacka'
    let menuItemId = '1243'

    if (htmlLang === 'sk') {
        menuItemId = '2224'
    }
    $(`.menu-item-${menuItemId} .menu-level-2 li a`).each(function () {
        const $link = $(this)
        const currentHref = $link.attr('href')

        if (currentHref) {
            let cleanHref = currentHref.replace(/-\d+\/?$/, '/')

            if (!cleanHref.endsWith('/')) {
                cleanHref += '/'
            }

            if (!cleanHref.startsWith(prefix)) {
                $link.attr('href', prefix + cleanHref)
            }
        }
    })
}

// Shared functions
function addWidthToMenuLevel2() {
    const container = $('.navigation-wrapper')

    document.documentElement.style.setProperty('--menu-level-2-width', `${container.width()}px`)
}

function navigationHighlightedCategories() {
    const currentLanguage = getShoptetDataLayer('language')

    const categories = categoriesByLanguage[currentLanguage] || categoriesByLanguage.cs

    categories.forEach((categoryData) => {
        const category = $(`#navigation .menu-level-1 .menu-item-${categoryData.id}`)
        category.addClass('highlighted-menu-item')
        category.css('background-color', categoryData.color)
    })
}

function changeSubcategoriesImagesSrc() {
    $('.menu-image img').each(function () {
        const $img = $(this)
        const currentSrc = $img.attr('src')
        const currentDataSrc = $img.attr('data-src')

        if (currentSrc && currentSrc.includes('/thumb/')) {
            $img.attr('src', currentSrc.replace('/thumb/', '/orig/'))
        }
        if (currentDataSrc && currentDataSrc.includes('/thumb/')) {
            $img.attr('data-src', currentDataSrc.replace('/thumb/', '/orig/'))
        }
    })
}

function addMobileMenuHeading() {
    $(`<h3 class="mobile-menu-heading">${_t('header.mobileMenuHeading')}</h3>`).prependTo(
        '.menu .menu-level-1'
    )
}

function addContactInfo() {
    const topNavBarClone = $('.top-navigation-bar').clone()
    const elementsToRemove = ['.top-navigation-info-bar', '.top-navigation-tools']

    elementsToRemove.forEach((selector) => {
        topNavBarClone.find(selector).remove()
    })

    topNavBarClone.appendTo('#navigation .navigation-in')

    $('.top-navigation-menu').prepend(`<H3 class="mobile-menu-heading">${_t('header.otherCategories')}</H3>`)
}
